import { useContext, createContext } from "react";
import ReactDOM from "react-dom";

const ModalPortal = ({ children, target }) => {
  const modalTarget = target ? target : 'model-container'
  const modalContext = createContext(modalTarget)
  const modelId = useContext(modalContext);
  const modalRoot = document.getElementById(modelId);
  return ReactDOM.createPortal(children, modalRoot);
};
export default ModalPortal;
